define('vspot-angular/services/activity-limit-service',[], function () {
    'use strict';

    return ['resources.ActivityLimit', function (ActivityLimit) {
        return {
            /**
             * Set limit on number of spots someone can sign up for
             * @param  {int}    selectedActivity     the activity to be acted upon
             * @param  {int}    jobassignmentsPerActivity - this is the limit for how many spots one user can have on this activity   
             * @param  {int}    jobassignmentsPerJob  placeholder for if/when we limit spots/assignments by job instead of limiting by activity.
             */
            create: function(selectedActivity, jobassignmentsPerActivity, jobassignmentsPerJob, jobassignmentsPerDay, jobassignmentsPerWeek, callback) {
                return ActivityLimit.create({
                    selected_activity:              selectedActivity,
                    jobassignments_per_activity:    jobassignmentsPerActivity,
                    jobassignments_per_job:         jobassignmentsPerJob,
                    jobassignments_per_day:         jobassignmentsPerDay,
                    jobassignments_per_week:        jobassignmentsPerWeek

                }, callback);
            },
            update: function(id, selectedActivity, jobassignmentsPerActivity, jobassignmentsPerJob, jobassignmentsPerDay, jobassignmentsPerWeek) {
                return ActivityLimit.update({
                    id:                             id, 
                    selected_activity:              selectedActivity,
                    jobassignments_per_activity:    jobassignmentsPerActivity,
                    jobassignments_per_job:         jobassignmentsPerJob,
                    jobassignments_per_day:         jobassignmentsPerDay,
                    jobassignments_per_week:        jobassignmentsPerWeek
                });
            },
            delete: function(id, selectedActivity) {
                return ActivityLimit.delete({
                    id:                       id,
                    selected_activity:        selectedActivity
                });
            }
        };
    }];
});

